/* eslint-disable no-restricted-syntax */
const formValues = (elements) => {
  const values = {};
  for (const element of elements) {
    if (element.id !== '') {
      values[element.id] = element.value;
    }
  }
  return values;
};
/* eslint-enable no-restricted-syntax */

export default formValues;
